export const text = {
  subcategory: "Product Subcategory",
};
